import { render } from "./CustomAutocompleteCoveringCertificate.vue?vue&type=template&id=bb7d271c"
import script from "./CustomAutocompleteCoveringCertificate.vue?vue&type=script&lang=js"
export * from "./CustomAutocompleteCoveringCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__